import { apiClient, writeActiveOrganizationId } from './client';
import type {
  AccessibleApplicationsResponse,
  MeResponse,
  UserOrganizationsResponse,
  SetActiveOrganizationResponse,
  RegisterAccountRequest,
  RegisterAccountResponse,
} from './types';

export const authApi = {
  register(body: RegisterAccountRequest): Promise<RegisterAccountResponse> {
    return apiClient.post<RegisterAccountResponse>('/v1/auth/register', body).then((r) => r.data);
  },

  me(): Promise<MeResponse> {
    return apiClient.get<MeResponse>('/v1/auth/me').then((r) => {
      writeActiveOrganizationId(r.data.activeOrganizationId);
      return r.data;
    });
  },

  organizations(): Promise<UserOrganizationsResponse> {
    return apiClient.get<UserOrganizationsResponse>('/v1/auth/organizations').then((r) => {
      writeActiveOrganizationId(r.data.activeOrganizationId);
      return r.data;
    });
  },

  applications(): Promise<AccessibleApplicationsResponse> {
    return apiClient.get<AccessibleApplicationsResponse>('/v1/auth/applications').then((r) => {
      writeActiveOrganizationId(r.data.activeOrganizationId);
      return r.data;
    });
  },

  setActiveOrganization(organizationId: string): Promise<SetActiveOrganizationResponse> {
    return apiClient.post<SetActiveOrganizationResponse>('/v1/auth/active-organization', { organizationId }).then((r) => {
      writeActiveOrganizationId(r.data.activeOrganizationId);
      return r.data;
    });
  },
};
